import React from 'react';
import styled from 'styled-components';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { useTranslations } from '@libs/translations';
import { TitleCard } from './title-card';
import { DescriptionCard } from './description-card';
import { Points } from '@styles';

export const Tokens = () => {
  const translations = useTranslations();
  return (
    <View>
      <Content>
        <TitleCard text={translations.t('site.home.opportunities.tokens.title')} />
        <DescriptionCard text={translations.t('site.home.opportunities.tokens.description')} />
      </Content>
    </View>
  );
};

const View = styled.div`
  position: relative;
  padding: 16px 16px 40px;
  height: 380px;
  color: ${Colors.main_black};
  border-radius: 15.13px;
  background-color: ${Colors.white};

  &::after {
    content: '';
    position: absolute;
    bottom: 16px;
    right: 16px;
    width: 100px;
    height: 100px;
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100' viewBox='0 0 100 100' fill='none'%3e%3cpath d='M45.8335 10.4165H56.5478C78.2447 10.4165 95.8335 28.1432 95.8335 49.8401C95.8335 70.8779 79.366 88.3665 58.3572 89.4723L56.2502 89.5832H45.8335' stroke='%23292929' stroke-width='4.16667'/%3e%3crect x='4.16667' y='10.4167' width='79.1667' height='79.1667' rx='39.5833' stroke='%23292929' stroke-width='4.16667'/%3e%3cpath d='M68.75 31.25V50C68.75 50 58.5326 40.6209 48.3984 38.1123C45.8374 55.5631 53.125 75 53.125 75H34.375C34.375 75 41.6613 55.5632 39.1006 38.1123C28.9667 40.6213 18.75 50 18.75 50V31.25H68.75Z' fill='%23292929'/%3e%3c/svg%3e");
  }

  @media ${Points.tablet_landscape} {
    padding: 30px 30px 40px;

    &::after {
      bottom: 15px;
      right: 30px;
    }
  }

  @media ${Points.laptop_wide} {
    height: 500px;
    padding: 40px;
    border-radius: 20px;

    &::after {
      bottom: 20px;
      right: 40px;
      width: 180px;
      height: 180px;
      background-repeat: no-repeat;
      background-size: cover;
    }
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 10px;

  @media ${Points.tablet_landscape} {
    gap: 15px;
  }

  @media ${Points.laptop_wide} {
    gap: 20px;
  }
`;